import React from 'react';
import {
    Bullet,
    BulletIconContainer,
    Container,
    Desc,
    Heading,
    IconContainer,
    LeftSection,
    Points,
    RightSection,
    Text,
} from './idFrauds.style';
import CheckMarkIcon from '../../../../images/Icons/icon-checkmark-styled.svg';
import PropTypes from 'prop-types';

const IdFrauds = ({ data, reverse = false }) => {
    return (
        <Container reverse={reverse}>
            <LeftSection>
                <IconContainer>
                    <img src={data.icon} alt="icon" />
                </IconContainer>
                <Heading>{data.heading}</Heading>
                <Desc>{data.desc}</Desc>
                <Points>
                    {data?.points?.map((point) => (
                        <Bullet key={point}>
                            <BulletIconContainer>
                                <img src={CheckMarkIcon} alt="check-mark-icon" />
                            </BulletIconContainer>
                            <Text>{point}</Text>
                        </Bullet>
                    ))}
                </Points>
            </LeftSection>
            <RightSection>
                <img src={data?.img} alt="data illustration" />
            </RightSection>
        </Container>
    );
};

IdFrauds.propTypes = {
    data: PropTypes.object,
    reverse: PropTypes.bool,
};

export default IdFrauds;
